<template>
  <v-card>
    <v-card-text class="d-flex justify-space-between align-center">
      <div class="user-img d-flex align-center">
        <Avatar
          class="mr-2"
          :user="user"
          :initials="initialsReader"
          large
        />
        <div class="user-desc">
          <div class="d-flex user-name text-h4 font-weight-medium my-1">
            {{ user.name }}
          </div>
          <div class="d-flex user-phone">
            <v-icon class="user-icon" small>fa-phone</v-icon>
            <div>{{ user.phone }}</div>
          </div>
          <div class="d-flex user-addr">
            <v-icon class="user-icon" small>fa-map-marker-alt</v-icon>
            <div class="text-justify">
              {{ user.address }} - {{ user.zipCode + " " + user.city }}
            </div>
          </div>
          <div class="d-flex align-center sensor-country">
            <div class="d-flex justify-center">
              <div class="text-justify mr-2">
                <img
                  :src="`https://countryflagsapi.com/svg/${user.country.toLowerCase()}`"
                  width="25"
                  crossorigin="anonymous"
                />
              </div>
              {{ user.country }}
            </div>
          </div>
        </div>
      </div>
      <div class="sensor-desc-2 d-flex align-center">
        <div>
          <div class="d-flex justify-space-between sensor-created my-2">
            <div class="text-button">Inscrit</div>
            <div class="text-button">{{ user.createdAt | dateFilter }}</div>
          </div>
          <div class="d-flex justify-space-between sensor-connection my-2">
            <div class="mr-16 text-button">Nombre de capteurs</div>
            <div
              class="text-button d-flex align-center font-weight-bold grey--text"
            >
              <v-chip color="warning">
                <v-icon class="mr-2" small right>fa-hourglass-end</v-icon>
                à venir
              </v-chip>
            </div>
          </div>
          <!-- <div class="d-flex justify-space-between sensor-provider">
            <div class="text-button">Fournisseur</div>
            <div class="text-button font-weight-bold primaryColor--text">
              <v-img
                v-if="sensor.provider == 'ORANGE'"
                :src="orangeProvider"
                max-width="35"
              >
              </v-img>
              <v-img
                v-else-if="sensor.provider == 'OBJENIOUS'"
                :src="objeniousProvider"
                max-width="70"
              >
              </v-img>
              <v-img v-else :src="clientProvider" max-width="50"></v-img>
            </div>
          </div> -->
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Avatar from "@/components/avatar/Avatar";
import dateFilter from "@filters/dateFilter";

export default {
  name: "UserDescription",
  components: {
    Avatar,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    initialsReader() {
      const names = this.user.name.split(" ");
      if(names.length > 1) return names[0].charAt(0) + names[1].charAt(0);
      return this.user.name.charAt(0)+this.user.name.charAt(1);
    }
  },
  filters: {
    dateFilter,
  },
};
</script>

<style>
.user-icon {
  margin-right: 12px;
  padding: 5px 0;
}
</style>
